/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { dismissAnnouncement, State } from 'modules';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// eslint-disable-next-line no-restricted-imports
import { AnnouncementResponse } from 'types';

// eslint-disable-next-line no-restricted-imports
import { Popover, PopoverProps } from 'components/popover';
import moment from 'moment';
// eslint-disable-next-line no-restricted-imports
import { getLocaleAnnouncements } from 'selectors/announcements';
// eslint-disable-next-line no-restricted-imports
import { isUnread, setTacoShow } from 'util/application-storage/announcements';

import { Announcement } from './announcement';
import styles from './announcement.less';

// eslint-disable-next-line no-restricted-imports
import { forNamespace, forTemplate } from 'common/lib/util/i18n';

// eslint-disable-next-line no-restricted-imports
import Icon, { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';

const viewTitle = forNamespace('view title');
const format = forTemplate('header_announcements');
const socialUrls = forNamespace('social');

export const POPOVER_NAME = Symbol('ROO_ANNOUNCEMENT');

interface AnnouncementsProps {
  announcements: AnnouncementResponse[];
  loading: boolean;
}

interface DispatchProps {
  readonly dismissAnnouncement: (id: string) => void;
}

interface AllProps
  extends AnnouncementsProps,
    DispatchProps,
    Pick<PopoverProps, 'onClose' | 'target'> {}

class Announcements extends React.Component<AllProps> {
  componentDidMount() {
    if (this.props.announcements) {
      this.markAnnouncementsRead(this.props.announcements);
    }
  }

  componentDidUpdate(prevProps: AllProps) {
    if (prevProps.announcements.length !== this.props.announcements.length) {
      this.markAnnouncementsRead(this.props.announcements);
    }
  }

  onTrackAnalytics = (socialUrl: string) => {
    Analytics.trackUE({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.LANDING_TAB,
      context: {
        landingtab: socialUrl,
      },
    });
  };

  markAnnouncementsRead = (announcements: AnnouncementResponse[]) => {
    this.props.announcements.forEach((announcement) => {
      const { id } = announcement;
      if (isUnread(id)) {
        this.props.dismissAnnouncement(id);
      }
    });
    setTacoShow(
      moment()
        .add(1, 'hours')
        .valueOf(),
    );
  };

  render() {
    const { announcements, target } = this.props;

    let campaign = '';
    if (announcements.length > 0) {
      const urlPart = /\/\/^https?:\/\/(?:[-a-z]+\.)?blog\.trello\.com\/([^/]+)\/\//.exec(
        announcements[0].url,
      );
      campaign = urlPart ? urlPart[1] : 'none';
    }

    if (/\?/g.test(campaign)) {
      campaign = campaign.replace(/\?/gi, '&');
    }

    let blogQuery = `?utm_campaign=${campaign}`;

    if (!/utm_source/.test(campaign)) {
      blogQuery += '&utm_source=direct';
    }

    if (!/utm_medium/.test(campaign)) {
      blogQuery += '&utm_medium=inapp';
    }

    return (
      <Popover
        name={POPOVER_NAME}
        target={target}
        title={viewTitle('announcements')}
        width={304}
        contentClassName={styles.popoverContent}
      >
        {() => (
          <div>
            {announcements.map((announcement) => (
              <Announcement key={announcement.id} {...announcement} />
            ))}
            <div className={styles['announcement-elsewhere']}>
              <p className={styles.quiet} style={{ margin: '0 4px 5px' }}>
                {format('for-more-updates-check-out-ellipsis')}
              </p>

              <a
                className={styles['announcement-elsewhere-blog']}
                target="_blank"
                rel="noopener noreferrer"
                href={`${socialUrls('blog')}${blogQuery}`}
                onClick={() => this.onTrackAnalytics(socialUrls('blog'))}
              >
                <Icon
                  className={styles['announcement-elsewhere-blog-icon']}
                  name={IconName.Board}
                  large
                />
                <span className={styles.underline}>
                  {format('trello-blog')}
                </span>
              </a>

              <a
                className={styles['announcement-elsewhere-social']}
                target="_blank"
                rel="noopener noreferrer"
                href={socialUrls('twitter')}
                onClick={() => this.onTrackAnalytics(socialUrls('twitter'))}
              >
                <Icon name={IconName.Twitter} large />
              </a>
              <a
                className={styles['announcement-elsewhere-social']}
                target="_blank"
                rel="noopener noreferrer"
                href={socialUrls('facebook')}
                onClick={() => this.onTrackAnalytics(socialUrls('facebook'))}
              >
                <Icon name={IconName.Facebook} large />
              </a>
              <a
                className={styles['announcement-elsewhere-social']}
                target="_blank"
                rel="noopener noreferrer"
                href={socialUrls('instagram')}
                onClick={() => this.onTrackAnalytics(socialUrls('instagram'))}
              >
                <Icon name={IconName.Instagram} large custom />
              </a>
            </div>
          </div>
        )}
      </Popover>
    );
  }
}

function mapStateToProps(state: State) {
  return {
    loading: state.models.announcements.loading,
    announcements: getLocaleAnnouncements(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<State>) {
  return {
    dismissAnnouncement(id: string) {
      dispatch(dismissAnnouncement(id));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Announcements);



// WEBPACK FOOTER //
// ./app/gamma/src/components/popovers/announcements/index.tsx